import {CA_showHelp} from "./nav";
import {createListElement, getElmText, removeAllChildrenOfElement, setElementText} from "./dom";
import TimeAgo from 'javascript-time-ago';
import * as Locales from 'javascript-time-ago/load-all-locales';
import {getSuffix} from "./strings";
import {revertFormFromLoadingState} from "../logic/form/form-buttons";

export function isMobileOrTablet() {
    let check = false;
    (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
}


export function getSelectRowValue(select, index) {
    if (index < select.length && index >= 0)
        return select.options[index].value;
    else
        return "";
}

export function setSelectRow(select, index, value, text) {
    if (index < select.length && index >= 0) {
        select.options[index].text = text;
        select.options[index].value = value;
    }
}

export function appendSelectRow(select, value, text) {
    select.options[select.length] = new Option(text, value);
}

/*
	Given an array of select indicies they will be removed from the specified select component.
	Note that calling this function will modify 'indicies' by sorting them
*/
function deleteSelectRows(select, indicies, dontSort) {
    indicies.sort(cmp_number_asc);

    //ensure the max and min indicies are within the select
    let selOpts = select.options;
    if (selOpts.length > 0	//at least 1 option?
        && indicies[0] > -1	//min index is valid?
        && indicies[indicies.length - 1] < selOpts.length)	//maximum index is valid?
    {
        var i = indicies.length - 1;  //start on the largest index
        while (i > -1)
        {
            selOpts[indicies[i]] = null;
            i--;
        }
    }
}


/*
  Selects a single index.
*/
export function setSelectSelection(select, index) {
    if (index >= 0 && index < select.options.length) {
        //clear all selections
        for (let i = 0; i < select.options.length; i++) {
            if (select.options[i].selected)
                select.options[i].selected = false;
        }

        //add the selection
        select.options[index].selected = true;
    }
}

/*
  Selects a single index.
*/
export function CA_setSelectSelectionByValue(select, value) {
    //clear all selections
    let oldSelectionIdx = -1;
    let found = false;
    for (let i = 0; i < select.options.length; i++)
    {
        if (select.options[i].selected)
            oldSelectionIdx = i;

        if (select.options[i].value == value) {
            select.options[i].selected = true;
            found = true;
        } else
            select.options[i].selected = false;
    }
}

/*
	Get all the selected indicies for an HTML form select.  This function returns an array of integer values.  If there is nothing selected the array length will be 0.
	For example:  alert(CA_getSelectSelections(document.TestForm.mySelect).length);
*/
export function getSelectSelections(select) {
    const opts = select.options;
    let result = [];
    //count the number of selections
    for (let i = 0; i < opts.length; i++) {
        if (opts[i].selected)
            result.push(i);
    }
    return result;
}
/*
	Returns the index of the first selection or -1 if nothing is selected.
*/
export function getSelectSelection(select) {
    const selections = getSelectSelections(select);
    if (selections.length > 0)
        return selections[0];
    else
        return -1;
}

export function getSelectedRadio(radioElm) {
    for (let i = 0; i < radioElm.length; i++) {
        if (radioElm[i].checked)
            return radioElm[i];
    }
    return null;
}

export function deleteSelectRow(select, index) {
    if (index < select.length && index >= 0)
        select.options[index] = null;
}

export function selectRadio(radioElm, newValue) {
    newValue = String(newValue);
    for (let i = 0; i < radioElm.length; i++)
        radioElm[i].checked = radioElm[i].value == newValue;
}

/*
  Gets the checked option for a group of radio buttons.  If there is a checked option
  it returns the option value as a string.  If there is no checked option it returns null.
*/
export function getRadioOption(radioGroup) {
    let len = radioGroup.length;
    let i = 0;
    while (i < len) {
        if (radioGroup[i].checked)
            return radioGroup[i].value;
        i++;
    }
    return null;
}

/**
 Lookup a string from a string table created with the vdx:jsStringLookup tag.
 */
export function jsStringLookup(stringTableId, itemId) {
    const elm = document.getElementById(stringTableId + itemId)
    if (elm)
        return getElmText(elm);
    else {
        //make sure the given lookup table even exists
        if (!document.getElementById('jsSL_' + stringTableId))
            throw 'jsStringLookup: unable to find lookup table "' + stringTableId + '"';
        else
            return null;
    }
}

export function isWhiteSpaceChar(aChar) {
    return aChar == " " || aChar == "\t" || aChar == "\xA0" || aChar == "\n" || aChar == "\r";
}

/**Use this to sort arrays of numbers in ascending order.  By default
 JavaScript's Array.sort() method does a lexicographical sort.
 Usage: [3,2,1].sort(cmp_number_asc) */
export function cmp_number_asc(a, b) {
    return a - b;
}

/*
  Find the first occurance of elm in the array a.
  Returns the index or -1 if elm is not contained in a.
*/
export function arrayIndexOf(a, elm) {
    for (let i = 0; i < a.length; i++) {
        if (a[i] == elm)
            return i;
    }
    return -1;
}

/**show or hide an html element using it's 'display' property.  If the element is already
 hidden it will be made visible and vice-versa.  Example:

 toggleItemVis(document.getElementById("myItem"));

 @param initiallyVisible specify wether the element is initially visible or hidden.  Ommit this to auto-detect
 as best as possible.
 @param visibleValue ommit this parameter null to auto detect.  This is the display property value to be used
 when making the item visible (usually 'block' or 'inline')
 @return true if the item became visible as a result of this call, false otherwise.
 */
export function toggleItemVis(elmRef, initiallyVisible, visibleValue) {
    //guess the correct visibile value if one was not provided
    if (!visibleValue) {
        if (elmRef.nodeName == 'SPAN' || elmRef.nodeName == 'A')
            visibleValue = 'inline';
        else
            visibleValue = 'block';
    }

    let currentlyVisible;

    //if the CSS display property is undefined then this is the first toggle so use the initiallyVisible flag
    if (!elmRef.style.display) {
        //the initiallyVisible flag was not provided explicitly?
        if (!initiallyVisible && initiallyVisible != false)
            //assume an undefined display value means it's initially visible
            currentlyVisible = true;
        else
            currentlyVisible = initiallyVisible;
    } else {
        currentlyVisible = elmRef.style.display == visibleValue;
    }

    if (currentlyVisible) {
        elmRef.style.display = 'none';
        return false;
    } else {
        elmRef.style.display = visibleValue;
        return true;
    }
}

/*return true if the given form input is readonly*/
export function isReadonly(input) {
    const roval = input.getAttribute("readonly");
    if (roval) {
        //IE treats gives a boolean
        if (typeof(roval) == 'boolean')
            return roval;
        //other browsers give a string
        else
            return roval.toLowerCase() == 'readonly';
    }
}

/*give keyboard focus to the first "text" "password" or textarea input on the page that is not disabled or readonly
	@param theForm - pass a reference to the form to constrain the search (optional)
*/
export function focusFirstTextInput(theForm) {
    if (!theForm)
        theForm = null;

    const inputs = document.getElementsByTagName("input");
    let foundInput = null;
    for (let i = 0; i < inputs.length; i++) {
        const input = inputs[i];
        if (
            (theForm == null || input.form == theForm)
            && (input.type == "text" || input.type== "password" || input.type == "file")
            && !input.disabled
            && !isReadonly(input)
            && input.name  //inputs without a name are bad candidates because they likely don't truly contribute to the form submission (like keyword filter box)
        ) {
            foundInput = input;
            break;
        }
    }

    const textareas = document.getElementsByTagName("textarea");
    for (let i = 0; i < textareas.length; i++) {
        const ta = textareas[i];
        if (
            (theForm == null || ta.form == theForm)
            && !ta.disabled
            && !isReadonly(ta)
        ) {
            foundInput = ta;
            break;
        }
    }

    if (foundInput) {
        //bugfix: if CAEntityTree_setSelectedNode() has been called it has set a pending timer which will
        //steal focus on IE and FF.  Cancel this timer.
        if (window.g_videx_scroll_bugfix_timer)
            window.clearTimeout(window.g_videx_scroll_bugfix_timer);

        foundInput.focus();
        return true;
    } else
        return false;
}

/**
 Substitute placeholders in a translated string. For example:

 var s = i18nSetMessageParams("The {0} cost {1,number} dollars!", "beans", 13);
 //s holds: "The beans cost 13 dollars!"
 */
export function i18nSetMessageParams(inputStr, p0, p1, p2) {
    let s = inputStr;
    if (typeof(p0) != 'undefined') {
        //regex must match either "{0}" or {0,word}
        s = s.replace(/\{0[,a-z]*\}/, '' + p0);
        if (typeof(p1) != 'undefined') {
            s = s.replace(/\{1[,a-z]*\}/, '' + p1);
            if (typeof(p2) != 'undefined') {
                s = s.replace(/\{2[,a-z]*\}/, '' + p2);
            }
        }
    }
    return s;
}

/** this should be called when the child page changes.  It updates the parent frame
 with information about the child */
export function update_child_info(helpTag) {
    // update child title
    const destElm = parent.document.getElementById("pageTitle"); // see <vdx:section-nav> tag
    const srcElm = document.getElementById("childTitle");
    if (destElm && srcElm)
        setElementText(destElm, getElmText(srcElm, true));
}

/**
 True if the lock serial is a 2nd generation CyberLock.
 2nd gen locks have serial numbers between L50xxxxxx and L5Fxxxxxx or L31xxxxxx
 */
export function isGen2LockSerial(serial) {
    if (serial
        && serial.length >= 3
        && serial.substring(0, 1).toUpperCase() == "L"
    ) {
        var val = parseInt(serial.substring(1, 3), 16);
        var parseOK = val == val;
        return parseOK && ((val >= 0x50 && val <= 0x5f) || val == 0x31);
    }
    return false;
}

export function installUnsavedChangesListener(form, vdxEventBus = null) {
    initChangeDetection(form);
    form.addEventListener('change', (e) => {
        if (formHasChanges((form))) {
            addUnsavedChangesListener();
        } else {
            removeUnsavedChangesListener();
        }
    });

    form.addEventListener('submit', (e) => {
        removeUnsavedChangesListener();
    });

    // add a drag n drop listener if there's one on the page
    if(vdxEventBus) {
        vdxEventBus.on('dnd-in-updated', (e) => {
            console.log("dnd-in-updated adding listener ", e);
            addUnsavedChangesListener();
        });
    }
}

export function addUnsavedChangesListener() {
    window.addEventListener('beforeunload', showUnsavedChangesPrompt);
}

export function removeUnsavedChangesListener() {
    window.removeEventListener('beforeunload', showUnsavedChangesPrompt);
}

// Displays the 'Stay on Page'/'Leave Page' confirmation prompt for form pages with unsaved changes.
function showUnsavedChangesPrompt(e) {
    const activeElement = document.activeElement;
    if (activeElement) {
        const name = activeElement.getAttribute('name');
        if (name === 'btnSave' || name === 'CANCEL') {
            // Save and Cancel button clicks shouldn't display unsaved changes prompt.
            return;
        }
    }
    e.returnValue = i18n.common.areYouSure;
}

function getOrigValueFromFormElement(el, form) {
    if (el.type === 'checkbox') {
        return el.checked;
    } else if (el.type === 'radio') {
        return form[el.name].value;
    }
    return el.value;
}

function initChangeDetection(form) {
    Array.from(form).forEach(el => {
        el.dataset.origValue = getOrigValueFromFormElement(el, form);
        el.dataset.excludeFromUnsavedChangesDetection = 'false';
    });
}

function doesFormElementHaveChanges(el, checkedRadioButtons, form) {
    if (el.dataset.excludeFromUnsavedChangesDetection === 'true') {
        return false;
    } else if (el.type === 'checkbox') {
        return el.dataset.origValue !== el.checked.toString();
    } else if (el.type === 'radio' && checkedRadioButtons.includes(el.name)) {
        return false;
    } else if (el.type === 'radio') {
        checkedRadioButtons.push(el.name);
        return el.dataset.origValue !== form[el.name].value;
    } else if (el.type === 'hidden')
        return false;
    return el.dataset.origValue !== el.value;
}

function formHasChanges(form) {
    const checkedRadioButtons = [];
    return Array.from(form).some(el => {
        return doesFormElementHaveChanges(el, checkedRadioButtons, form);
    });
}

export function excludeElementFromUnsavedChangesDetection(el) {
    el.dataset.excludeFromUnsavedChangesDetection = 'true';
}

export const isCyberLockBluePadlock = (serial) => {
    return serial
        && serial.length === 9
        && serial[1] === '7'
        && serial[2] === '1';
}

export const isCyberLockBlue = (serial) => {
    return serial
        && serial.length === 9
        && serial[1] === '7';
}

export const isCyberLockBlueKeyBox = (serial) => {
    return serial
        && serial.length === 9
        && serial[1] === '7'
        && serial[2] === '4';
}

export const isNFCPadlock = (serial) => {
    return serial
        && serial.length === 9
        && serial[1] === '7'
        && serial[2] === '3';
}

export const isNFC = (serial) => {
    return serial
        && serial.length === 9
        && serial[1] === '7'
        && serial[2] === '2';
}

export const isFlexEdge = (serial) => {
    return serial
        && serial.length === 9
        && serial[0] === 's'
        && serial[1] === '1'
        && serial[2] === '0';
}

/**
 * Returns icon src string for the given item type key in javascript-webpack-config.json.
 * The function searches first to see if the itemType key is found in 'itemData' and if so,
 * uses the 'icon' property. Otherwise, it checks the 'icons' table for the path.
 *
 * EX 1: getWebpackConfigIcon('webAuth') -> gets WebpackConfig.itemData['webAuth'].icon.
 * EX 2: getWebpackConfigIcon('auditReport') -> gets WebpackConfig.icons['auditReport'].
 */
export const getWebpackConfigIcon = (itemType) => {
    const { itemData, icons } = WebpackConfig;
    if (itemData.hasOwnProperty(itemType))
        return itemData[itemType].icon;
    if (icons.hasOwnProperty(itemType))
        return icons[itemType];
    return {};
}

/**
 * Returns specified link value from WebpackConfig (javascript-webpack-config.json) for the
 * provided itemType/link key pair.
 *
 * EX 1: getWebpackConfigIcon('cyberlock', 'addNew') -> gets WebpackConfig.itemData['cyberlock'].links['addNew'].
 *
 * This returns the *UNREPLACED* value with placeholders. Run the getWebpackConfigUrlWithReplacedParams()
 * to replace the params.
 */
export const getWebpackConfigLinkWithReplacedParams = (itemType, linkKey, itemId, adminNode) => {
    const linkValue = getWebpackConfigLinkValue(itemType, linkKey);
    if (!linkValue)
        return null;
    return getUrlWithReplacedParams(linkValue, itemId, adminNode);
}

const getWebpackConfigLinkValue = (itemType, linkKey) => {
    const { itemData } = WebpackConfig;
    if (itemData.hasOwnProperty(itemType) && itemData[itemType].links) {
        return itemData[itemType].links[linkKey];
    }
    return null;
}

/**
 * @param url - link value string (eg '/CyberAuditWeb/locks/AddEditCtrl.act?addToNode={0}').
 * 			    Nominally use itemData to determine this value. EG if you want the addNew
 * 			    link of cyberlocks, use the value of
 *
 * 			    	WebpackConfig.itemData['cyberlock'].links.addNew
 *
 * 			    as the 'url' param for this function.
 * @param selectedItemId - optional. Specify the itemId that will replace the item id placeholder.
 * 						   Uses WebpackConfig.ent.selectedItemIdOptions array. If the url has one of
 * 						   the items in this array, it will be replaced. For example...
 *
 * 						   	Use Case 1:
 * 						   		- getWebpackConfigUrlWithReplacedParams(
 * 						   			WebpackConfig.itemData['person'].links.accessToVault,
 * 						   			123,
 * 						   			null
 * 						   		)
 * 						   		- The URL in this case will be '/CyberAuditWeb/people/VaultAccessCtrl.act?personId={0}.
 * 						   		- Because 'personId' is in the selectedItemIdOptions array, the 'personId={0}' part
 * 						   		  of the string will be replaced with 'personId=123'.
 * 						   		- The number inside the placeholder (eg '0' ion {0}) is arbitrary.
 * 						   		- If left as null, no substitution will occur.
 * @param adminNode - optional. Similar to the itemId, specifies the admin node for the URL. This is often used
 * 					  in cases like adding an item to a particular subsystem admin node. Check 'adminNodeOptions'
 * 					  in WebpackConfig.ent to see which keywords are specified. If you do not see the keyword for
 * 					  the URL you've added, please add it to javascript-webpack-config.json.
 *
 * @returns {*}
 */
export const getUrlWithReplacedParams = (url, selectedItemId, adminNode) => {
    // URLs in CAW often require the item id and/or admin node id as a parameter.
    // This function will automatically apply the item id and/or admin node if the parameter
    // exists in the form of itemId={0}&nodeId={1}.
    // The options arrays are found in javascript-webpack-config.json and this function is used
    // for urls in the context of `javascript-webpack-config.json` -> itemType property.
    const {selectedItemIdOptions, adminNodeOptions} = WebpackConfig.ent;

    for (let i = 0; i < 2; i++) {
        if (selectedItemId) {
            for (let j = 0; j < selectedItemIdOptions.length; j++) {
                if (url.includes(`${selectedItemIdOptions[j]}={${i}}`)) {
                    url = url.replace(`{${i}}`, selectedItemId);
                    break;
                }
            }
        }

        if (adminNode) {
            for (let j = 0; j < adminNodeOptions.length; j++) {
                if (url.includes(`${adminNodeOptions[j]}={${i}}`)) {
                    url = url.replace(`{${i}}`, adminNode);
                    break;
                }
            }
        }
    }

    if (url.includes('flexId=') && !url.includes('flexId={0}')) {
        url = url.replace('flexId=', 'flexId=F');
    }

    return url;
}

export const getFormattedMessage = (message, param1, param2, param3, param4) => {
    let newMessage = message;
    if (newMessage.includes('{0}') && param1 !== undefined) {
        newMessage = newMessage.replace('{0}', param1);
    }
    if (newMessage.includes('{1}') && param2 !== undefined) {
        newMessage = newMessage.replace('{1}', param2);
    }
    if (newMessage.includes('{2}') && param3 !== undefined) {
        newMessage = newMessage.replace('{2}', param3);
    }
    if (newMessage.includes('{3}') && param4 !== undefined) {
        newMessage = newMessage.replace('{3}', param4);
    }
    return newMessage;
}

// Use global variable to ensure that defaultLocale is only set once - it is necessary
// for ReactTimeAgo to work properly.
window.isDefaultLocaleSet = false;
export const setDefaultLocale = (serverSettings) => {
    if (window.isDefaultLocaleSet) {
        return;
    }
    if (serverSettings?.localeLanguage && Locales[serverSettings.localeLanguage]) {
        TimeAgo.setDefaultLocale(serverSettings.localeLanguage);
    } else {
        TimeAgo.setDefaultLocale('en');
    }
    window.isDefaultLocaleSet = true;
}

export const getAllBinaryExtensions = () => ['bin', 'dat', 'iso', 'exe', 'db', 'sql', 'mdb', 'com', 'bat', 'msi', 'sh'];
export const getAllDocExtensions = () => ['doc', 'docx', 'odt', 'rtf'];
export const getAllPdfExtensions = () => ['pdf'];
export const getAllImageExtensions = () => ['bmp', 'gif', 'ico', 'jpeg', 'jpg', 'png', 'svg', 'webp'];
export const getAllPowerpointExtensions = () => ['odp', 'pps', 'ppt', 'pptx'];
export const getAllSpreadsheetExtensions = () => ['csv', 'xml', 'ods', 'xls', 'xlsm', 'xlsx'];
export const getAllAudioExtensions = () => ['mp3', 'wav', 'wma'];
export const getAllVideoExtensions = () => ['avi', 'mp4', 'mpg', 'mpeg', 'webm', 'wmv'];
export const getAllCompressedExtensions = () => ['7z', 'deb', 'pkg', 'rar', 'rpm', 'tar', 'gz', 'z', 'zip'];
export const getAllTextExtensions = () => ['txt', 'tex'];

export const getSupportedImageExtensionsString = () => {
    return arrayToCommaSeparatedString(getAllImageExtensions().map((value) => `.${value}`));
}

export const getSupportedFileExtensionsString = () => {
    return arrayToCommaSeparatedString(getSupportedFileExtensions().map((value) => `.${value}`));
}

export const getSupportedFileExtensions = () => {
    return getAllDocExtensions().concat(
        getAllPdfExtensions(),
        getAllImageExtensions(),
        getAllPowerpointExtensions(),
        getAllSpreadsheetExtensions(),
        getAllAudioExtensions(),
        getAllVideoExtensions(),
        getAllCompressedExtensions(),
        getAllTextExtensions()
    );
}

export function arrayToCommaSeparatedString(fileExtensions) {
    return fileExtensions.join(', ');
}

export const getAllExtensions = () => {
    return getAllBinaryExtensions().concat(
        getAllDocExtensions(),
        getAllPdfExtensions(),
        getAllImageExtensions(),
        getAllPowerpointExtensions(),
        getAllSpreadsheetExtensions(),
        getAllAudioExtensions(),
        getAllVideoExtensions(),
        getAllCompressedExtensions(),
        getAllTextExtensions()
    );
};

export const getExtensionIcon = (fileName, shouldBeValidExtension = false) => {
    const { icons } = WebpackConfig;
    const fileExtension = getSuffix(fileName);
    if (shouldBeValidExtension && !fileExtension) {
        return null;
    }

    if (getAllBinaryExtensions().includes(fileExtension)) {
        return icons.extBinary;
    } else if (getAllDocExtensions().includes(fileExtension)) {
        return icons.extDoc;
    } else if (getAllPdfExtensions().includes(fileExtension)) {
        return icons.extPdf;
    } else if (getAllImageExtensions().includes(fileExtension)) {
        return icons.extPng;
    } else if (getAllPowerpointExtensions().includes(fileExtension)) {
        return icons.extPptx;
    } else if (getAllSpreadsheetExtensions().includes(fileExtension)) {
        return icons.extXlsx;
    } else if (getAllAudioExtensions().includes(fileExtension)) {
        return icons.extAudio;
    } else if (getAllVideoExtensions().includes(fileExtension)) {
        return icons.extVideo;
    } else if (getAllCompressedExtensions().includes(fileExtension)) {
        return icons.extZip;
    } else if (getAllTextExtensions().includes(fileExtension)) {
        return icons.extTxt;
    }

    return icons.extPlain;
}

export function getFormattedBytesLabel(bytes) {
    if (!bytes || bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}

const mimeTypes = {
    'bin': 'application/octet-stream',
    'dat': 'application/octet-stream',
    'iso': 'application/x-iso9660-image',
    'exe': 'application/x-msdownload',
    'db': 'application/x-sqlite3',
    'sql': 'application/sql',
    'mdb': 'application/vnd.ms-access',
    'com': 'application/x-msdownload',
    'bat': 'application/x-msdownload',
    'msi': 'application/x-msdownload',
    'sh': 'application/x-sh',
    'doc': 'application/msword',
    'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'odt': 'application/vnd.oasis.opendocument.text',
    'rtf': 'application/rtf',
    'pdf': 'application/pdf',
    'bmp': 'image/bmp',
    'gif': 'image/gif',
    'ico': 'image/vnd.microsoft.icon',
    'jpeg': 'image/jpeg',
    'jpg': 'image/jpeg',
    'png': 'image/png',
    'svg': 'image/svg+xml',
    'webp': 'image/webp',
    'odp': 'application/vnd.oasis.opendocument.presentation',
    'pps': 'application/vnd.ms-powerpoint',
    'ppt': 'application/vnd.ms-powerpoint',
    'pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'csv': 'text/csv',
    'xml': 'application/xml',
    'ods': 'application/vnd.oasis.opendocument.spreadsheet',
    'xls': 'application/vnd.ms-excel',
    'xlsm': 'application/vnd.ms-excel.sheet.macroenabled.12',
    'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'mp3': 'audio/mpeg',
    'wav': 'audio/wav',
    'wma': 'audio/x-ms-wma',
    'avi': 'video/x-msvideo',
    'mp4': 'video/mp4',
    'mpg': 'video/mpeg',
    'mpeg': 'video/mpeg',
    'webm': 'video/webm',
    'wmv': 'video/x-ms-wmv',
    '7z': 'application/x-7z-compressed',
    'deb': 'application/x-debian-package',
    'pkg': 'application/x-newton-compatible-pkg',
    'rar': 'application/vnd.rar',
    'rpm': 'application/x-rpm',
    'tar': 'application/x-tar',
    'gz': 'application/gzip',
    'z': 'application/x-compress',
    'zip': 'application/zip',
    'txt': 'text/plain',
    'tex': 'application/x-tex'
};

export function getMimeType(extension) {
    return mimeTypes[extension.toLowerCase()] || 'application/octet-stream';
}

export const downloadByteData = (byteData, fileName) => {
    const blob = new Blob([byteData], { type: getMimeType(getSuffix(fileName)) });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;

    document.body.appendChild(link);

    link.click();

    URL.revokeObjectURL(link.href);
    document.body.removeChild(link);
};

export function evaluateForValidForm(form, validationCallback) {
    const warningDiv = document.querySelector('.warningDiv');
    if (!form.btnSave || !warningDiv) {
        return true;
    }

    removeAllChildrenOfElement(warningDiv);
    const errors = validationCallback();

    const isValid = errors && errors.length === 0;
    warningDiv.style.display = !isValid ? 'block' : 'none';
    form.btnSave.disabled = !isValid;
    if (isValid) {
        return true;
    }

    warningDiv.appendChild(createListElement(errors));
    return false;
}

export function removeDuplicates(array) {
    return [...new Set(array)];
}

/**
 *
 * @param form Form document.
 * @param validationCallback Function that returns an array of error strings.
 * 			- EX: ['error 1', 'error 2', 'error 3']
 * 			- Return an empty array to indicate that form validation was
 * 			  successful and has no errors.
 */
export function installFormValidationListener(form, validationCallback) {
    form.addEventListener('change', (e) => {
        if (formHasChanges((form))) {
            evaluateForValidForm(form, validationCallback);
        }
    });

    form.addEventListener('submit', (e) => {
        if (!evaluateForValidForm(form, validationCallback)) {
            revertFormFromLoadingState(form);
            e.preventDefault();
            return false;
        }
    });
}

export function hasEmojis(message) {
    const emojiStrRegex = /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/gi;
    return getStringAsSingleLine(message).match(emojiStrRegex) !== null;
}

function getStringAsSingleLine(message) {
    return message.replace(/\r\n|\r|\n/g, " ");
}

export function isValidLatitude(latitude, canBeNull = true) {
    if (!latitude) {
        return canBeNull;
    }
    const lat = parseFloat(latitude);
    return !isNaN(lat) && lat >= -90 && lat <= 90;
}

export function isValidLongitude(longitude, canBeNull = true) {
    if (!longitude) {
        return canBeNull;
    }
    const lon = parseFloat(longitude);
    return !isNaN(lon) && lon >= -180 && lon <= 180;
}

// What number is 35% between 56 and 132? lergp(56, 132, 0.35)
export const lerp = (x, y, a) => x * (1 - a) + y * a;

// Returns a if between min and max, otherwise returns min or max
export const clamp = (a, min = 0, max = 1) => Math.min(max, Math.max(min, a));

// What is percentage of how far a is between x and y? invlerp(50, 100, 75) => 0.5.
// E.g. How far through this section has the user scrolled?
export const invlerp = (x, y, a) => clamp((a - x) / (y - x));

// Converts a value from one data range to another (range(10, 100, 2000, 20000, 50) // 10000
export const range = (x1, y1, x2, y2, a) => lerp(x2, y2, invlerp(x1, y1, a));

export function getLocaleLanguage() {
    return getPageDataItem('localeLanguage') || 'en';
}

export function getLocaleLanguageDir() {
    return getPageDataItem('localeLanguageDir');
}

export function getDateTimeSecFormat() {
    return getPageDataItem('dateTimeSecFormat');
}

export function getDateFormatPattern() {
    return getPageDataItem('dateFormatPattern');
}

export function getPageDataItem(key) {
    const { pageData } = GlobalEnt;
    return pageData[key] || null;
}